import {Merchant} from './Merchant';
import {Address} from './data/Address';
import { EmvBulkAddress } from './data/EmvBulkAddress';

export class Ship {
  userCreated: string;
  userModified: string;
  dateCreated: string;
  dateModified: string;
  copierChanged: false;
  copierValidated: false;
  shipLocation: string;
  shipName: string;
  hostName: string;
  shipHull: string;
  shipClass: string;
  shipCrewSize: number;
  lastRoundtrip: string;
  autoRoundTripInterval: string;
  pilot1: string;
  pilot2: string;
  isDecommissioned: string;
  isMarine: string;
  shipTycom: string;
  shipCinc: string;
  sfaNum: string;
  disboName: string;
  disboEmail: string;
  disboPhone: string;
  shipPort: string;
  lsrContact: string;
  phoneNumber: string;
  dssn: string;
  marineDssn: string;
  skipClinkInd: string;
  setClinkUser: string;
  setClinkDate: string;
  uic: string;
  name: string;
  hull: string;
  tycom: string;
  cinc: string;
  crewSize: number;
  enabled?: string;
  merchants?: Merchant[] = [];
  bulkAddress?: EmvBulkAddress;
  shipAddress?: Address;
  isEMV: string;
}
